import React from 'react';
import {IS_SEPARATED, ROOT_PATH, TRACK_PATH} from "@constants/config";
import {useAppContext} from "@context/appContext/hooks/useAppContext";
import {Box, Typography} from "@mui/material";

const sx = {
    logo: {
        paddingLeft: '5px'
    },
    logoTitle: {
        color: "#fff",
        backgroundColor: "rgba(255,255,255,.1)",
        borderRadius: "10px",
        padding: "2px 8px"
    },
}
const Logo = () => {

    const {settings} = useAppContext()

    return (
        <Box sx={sx.logo}>
            <a
                href={IS_SEPARATED ? ROOT_PATH : `${TRACK_PATH}/dashboard`}
                title=""
                className="logo"
            >
                {settings?.logoUrl ? <img src={settings?.logoUrl} alt=""/> :

                    <Typography
                        sx={sx.logoTitle}
                        variant={'body2'}
                    >
                        UA-GIS TREK
                    </Typography>}
            </a>
        </Box>
    );
};

export default Logo;